import { useEffect, useContext, useState } from "react";
import Utils from "../../Utils";
import axios from "axios";

import PhNotifications from "../../components/photographer/PhNotifications";
import PhCertification from "../../components/photographer/PhCertification";

const PhDashboard = (props) => {

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });
  };
  const getAttrArr = (hotelAttrs) => {
    if (!hotelAttrs) return '';

    const parts = hotelAttrs.split('#');
    return parts;
  };

  /* Hotel types */
  const hotel_types = {
    "new": "New Property",
    "converted": "Converted Property",
    "established": "Established Property",
  };

  /* Classes for specific status */
  const statusClasses = {
    "In-Process": "status-pill inline-block bg-yellow-100 text-yellow-800",
    "Pending": "status-pill inline-block bg-pink-50 text-pink-700",
    "Completed": "status-pill inline-block bg-gray-200 text-gray-700",
  };
  /* Labels for status */
  const getStatusLabel = (status) => {
    const code = Number(status);

    if (code === 0 || code === 1) return 'Pending';
    if (code >= 2 && code <= 6) return 'In-Process';
    if (code === 7 || code === 8) return 'Completed';

    return 'Unknown';
  };
  const hotelDetailsFromAttrs = (attrs) => {
    return attrs.split('#');
  }

  /* Getting status for number */
  const [status, setStatus] = useState([]);
  useEffect(() => {
    axios
        .get(Utils.apiUrl(`psstatus`), Utils.apiHeaders())
        .then((res) => {
          if(res.data.success) {
            setStatus(res.data.statuses);
          }
        })
        .catch((err) => {
          //callback(false, err.message);
        });
  }, []);

  const [photoshoots, setPhotoshoots] = useState([]);
  useEffect(() => {
    axios
        .get(Utils.apiUrl(`photoshoot/listing?sortBy=created_at&sortDir=desc`), Utils.apiHeaders())
        .then((res) => {
            console.log(res.data);
          if(res.data.success) {
            setPhotoshoots(res.data.data);
            //setHotelDetailsAttr(hotelDetailsFromAttrs(res.data.data[0].hotel_attrs));
          }
        })
        .catch((err) => {
          //callback(false, err.message);
        });
  }, []);


  return (
    <>
      <div className="container mx-auto px-8 py-8">
        <div class="h1-wrapper">
            <h1 className="text-3xl font-bold text-gray-800">Photographer Dashboard</h1>
            <div class="certification-icon-header" title="Certification Status">
                <i class="fas fa-check"></i>
                <div class="certification-tooltip">
                    <div><strong>Status:</strong> Active & Valid</div>
                    <div><strong>Expires:</strong> 30-Jun-2026</div>
                </div>
            </div>
        </div>

        {/* <!-- Notifications Section --> */}
        {/* <PhNotifications /> */}
        {/* <!-- Certification Status --> */}
        {/* <PhCertification /> */}

            {/* If photoshoots have data */}
            {photoshoots.length > 0 && (
                <>
                <div class="dashboard-section">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Photoshoots</h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
                    {photoshoots.map((record) => (
                        <article className="project-tile bg-white">
                            <div className="p-4 bg-white">
                                <div className="flex items-start justify-between">
                                    <div>
                                        <h2 className="text-lg font-semibold text-gray-800">{`${getAttrArr(record.hotel_attrs)[0]} - ${getAttrArr(record.hotel_attrs)[1]}`}</h2>
                                        <p className="text-sm text-gray-500 mt-1">Type: <span className="font-medium text-gray-700">{hotel_types[record.hotel_type]}</span></p>
                                        <p className="text-sm text-gray-500">Shoot Date: <span className="font-medium text-gray-700">{formatDate(record.date_from)} - {formatDate(record.date_to)}</span></p>
                                        <p className="text-sm text-gray-500">Photographer: <span className="font-medium text-gray-700">{record.photographer_name}</span></p>
                                        <p className="text-sm text-gray-500">Status: <span className="font-medium text-gray-700">{status[record.status]}</span></p>
                                    </div>
                                    <div className="ml-3 text-right">
                                        <div className={statusClasses[getStatusLabel(record.status)]}><i className="fa-solid fa-circle"></i></div>
                                    </div>
                                </div>

                                <div className="mt-4 flex space-x-3 text-xs">
                                    <a href={`photographer-photoshoot-details/${record.id}`} className="btn inline-flex items-center justify-center px-4 py-2 bg-gray-800 text-white rounded hover:bg-gray-700">
                                        <i className="fas fa-eye mr-2"></i> View Details
                                    </a>
                                    <a href="#" className="cta-btn inline-flex items-center justify-center px-4 py-2 border border-gray-300 text-gray-800 rounded hover:bg-gray-100 ctaBrandTeam">
                                        <i className="fas fa-comments mr-2"></i> Contact Brand Team
                                    </a>
                                </div>
                            </div>
                        </article>
                    ))}
                    </div>
                </div>
                </>
            )}

        {/* <!-- Photoshoot Request Creation Section --> */}
        {photoshoots.length > 0 && (
            <>
            <div className="dashboard-section">
                <div className="section-title">
                    <i className="fas fa-camera-retro"></i>
                    Photoshoot Request Details
                </div>
                {photoshoots.length > 0 && 
                photoshoots
                .filter(item => item.status === 0)
                .map((item) => (
                <div className="bg-gradient-to-r from-gray-50 to-gray-100 p-6 rounded-lg border border-gray-200 mb-2">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div>
                            <p className="text-sm text-gray-600 font-semibold uppercase tracking-wide mb-2">Hotel Name</p>
                            <p className="text-lg font-bold text-gray-800">{hotelDetailsFromAttrs(item.hotel_attrs)[0]}</p>
                        </div>
                        <div>
                            <p className="text-sm text-gray-600 font-semibold uppercase tracking-wide mb-2">Create Photoshoot Request</p>
                            <p className="text-lg font-bold text-gray-800">
                                <a href={`photographer-photoshoot-request/${item.id}`} className="btn px-4 py-2 rounded text-white font-semibold text-sm flex items-center space-x-2 hover:opacity-90">
                                    <i className="fa-regular fa-camera"></i>
                                    <span>Photoshoot Request</span>
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
                ))}
            </div>
            </>
        )}

        {/* <!-- Photoshoot Request Section --> */}
        {photoshoots.length > 0 && (
            <>
            <div className="dashboard-section">
                <div className="section-title">
                    <i className="fas fa-camera-retro"></i>
                    Recce Request Details
                </div>
                {photoshoots.length > 0 && 
                photoshoots
                .filter(item => item.status === 1)
                .map((item) => (
                <div className="bg-gradient-to-r from-gray-50 to-gray-100 p-6 rounded-lg border border-gray-200 mb-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div>
                            <p className="text-sm text-gray-600 font-semibold uppercase tracking-wide mb-2">Hotel Name</p>
                            <p className="text-lg font-bold text-gray-800">{hotelDetailsFromAttrs(item.hotel_attrs)[0]}</p>
                        </div>
                        <div>
                            <p className="text-sm text-gray-600 font-semibold uppercase tracking-wide mb-2">Date Range</p>
                            <p className="text-lg font-bold text-gray-800">
                                <i className="fas fa-calendar-alt text-gray-600"></i>
                                {formatDate(item.date_from)} to {formatDate(item.date_to)}
                            </p>
                        </div>
                    </div>
                    <div className="mt-6 pt-6 border-t border-gray-300 flex items-center justify-between">
                        <p className="text-sm text-gray-600 font-semibold uppercase tracking-wide">Status: {status[item.status]}</p>
                        {/* <span className="status-badge status-in-progress">
                            <i className="fas fa-hourglass-half"></i> In-Progress
                        </span> */}
                        <div className={statusClasses[getStatusLabel(item.status)]}><i className="fa-solid fa-circle"></i></div>
                    </div>

                    <div className="mt-4">
                        <a href={`photographer-photoshoot-details/${item.id}`} className="btn px-4 py-2 rounded text-white font-semibold text-sm flex items-center space-x-2 hover:opacity-90">
                            <i className="fas fa-file-alt"></i>
                            <span>Recce Deck</span>
                        </a>
                    </div>
                </div>
                ))}
            </div>
            </>
        )}

    </div>
    </>
  );
};

export default PhDashboard;
